import styled from 'styled-components'
import { gray, semantic } from 'sutra/tokens/colors'
import { motion } from 'sutra/tokens/motion'
import { radii } from 'sutra/tokens/radii'
import { shadows } from 'sutra/tokens/shadows'

// Above the ask-yogi floating chat (1000) and the notifications bell (1100),
// in the "modals 2000 and up" band noted in SignedInLayout.
export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 18vh 24px 24px;
  background: rgba(10, 13, 18, 0.5);
`

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 560px;
  max-height: 420px;
  background: ${semantic.bg};
  border-radius: ${radii.md}px;
  box-shadow: ${shadows.xl};
  overflow: hidden;
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 16px 20px;
  border: none;
  border-bottom: 1px solid ${semantic.border};
  outline: none;
  font-family: 'Poppins', system-ui, sans-serif;
  font-size: 14px;
  color: ${semantic.fg};
  background: transparent;

  &::placeholder {
    color: ${semantic.fgSubtle};
  }
`

export const ResultsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px;
`

export const SectionLabel = styled.div`
  padding: 8px 12px 2px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${semantic.fgSubtle};

  /* The list's own padding provides the top inset; without this the first
     heading gets the padding twice and reads unbalanced vs the bottom. */
  &:first-child {
    padding-top: 0;
  }
`

export const CommandRow = styled.button<{ $focused: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: ${radii.sm}px;
  background: ${({ $focused }) => ($focused ? gray[100] : 'transparent')};
  font-family: 'Poppins', system-ui, sans-serif;
  font-size: 13px;
  color: ${semantic.fg};
  text-align: left;
  cursor: pointer;
  transition: background ${motion.duration.base}ms ${motion.ease};

  &:hover {
    background: ${gray[100]};
  }
`

export const CommandIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  flex-shrink: 0;
  color: ${semantic.fgSubtle};
  font-size: 14px;
`

export const ContextPrefix = styled.span`
  flex-shrink: 0;
  color: ${semantic.fgSubtle};
`

export const Match = styled.strong`
  font-weight: 600;
`

export const EmptyState = styled.div`
  padding: 32px 24px;
  text-align: center;
  font-size: 13px;
  color: ${semantic.fgSubtle};
`
